module.exports = __webpack_public_path__ + "static/media/listing-image-placeholder.3e71e12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/listing-image-placeholder.png
// module id = 1247
// module chunks = 0